export default __webpack_public_path__ + "static/media/logo-wowflow.67d89118.svg";